import _ from 'underscore';
import Backbone from 'backbone';
import {OPEN, SELECTION_CHANGED} from 'common/constants';

Backbone.$ = $;

export default Backbone.View.extend({
  constructor(...args) {
    this.cachedOptions = [];
    this.defaults = {
      dropdownCssClass: 'select2-custom',
      minimumResultsForSearch: 20,
    };

    this.close = function () {
      this.$el.select2('close');
    };

    this.restoreFromCache = function (value) {
      const cache = this.cachedOptions;
      const previous = cache[cache.length - 1];
      if (previous) {
        this.$el.empty().append(previous);
        this.$el.val(value);
        if (this.getSelectedItem() !== value) {
          this.searchCache(value);
        }
        this.select2();
      }
    };

    this.searchCache = function (value) {
      // Loop through the cached options and try to find a set that contains 'value'
      // Then use that set as the current one, and update the selectors cache
      const cache = this.cachedOptions;
      for (let ii = 0, ll = cache.length; ii < ll; ii++) {
        let options = cache[ii];
        if (options.get(0).nodeName.toLowerCase() === 'optgroup') {
          options = options.children('option');
        }
        if (options.toArray().some((option) => option.value === value)) {
          this.$el.empty().append(options);
          this.$el.val(value);
          cache.splice(ii + 1, ll + 1);
          break;
        }
      }
    };

    this.select2 = function () {
      this.$el.select2(this.defaults);
    };

    this.onClick = function () {
      this.trigger(SELECTION_CHANGED, {
        selection: this.getSelectedItem(),
        target: this,
      });
    };

    this.events = {click: 'onClick'};

    // Has to happen here, before listeners
    // And after everything else.
    Backbone.View.apply(this, args);
    _.extend(this, Backbone.Events);

    const that = this;
    this.$el.on(OPEN, () => {
      that.trigger(OPEN, {target: that});
    });
  },

  getSelectedItemText() {
    return this.$el.find('option:selected').text();
  },

  getSelectedItem() {
    return this.$el.val();
  },

  setSelectedItem(value) {
    this.$el.val(value);
    this.select2();
  },

  validateSelection(selection) {
    const current = this.getSelectedItem();
    if (selection) {
      this.$el.val(selection);
      if (!this.getSelectedItem()) {
        this.$el.val(current);
      }
    }
    this.select2();
  },
});
